import { Component } from '@angular/core';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { CrawfordNavigationMenuService, CrawfordPageFooterService, CrawfordPageHeaderService,
  CrawfordSpinnerService } from 'crawford-shell';
import { global } from './app.settings';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private pageHeaderService: CrawfordPageHeaderService,
    private navigationMenuService: CrawfordNavigationMenuService,
    private footerService: CrawfordPageFooterService,
    private spinnerService: CrawfordSpinnerService,
  ) {
  }

  public ngOnInit(): void {
    this.spinnerService.startPageSpinner();
    this.setNavigation();
    this.setHeader();
    this.setFooter();
  }

  private setNavigation(): void {
    this.navigationMenuService.buildNavigationFromRoutes();
  }

  private setFooter(): void {
    this.footerService.set({footer: global.version});
  }

  private setHeader(): void {
    this.pageHeaderService.set({ logo: global.logo });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/app.component.ts